import { NgModule, APP_INITIALIZER }           from '@angular/core';
import { CommonModule }       from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';
import { TranslateModule } from '@ngx-translate/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { ClientsSocisListUTEsComponent } from './clients-socis-list/clients-socis-list.component';
import { DialogUtes } from './dialog.component.utes';

import { AngularMaterialModule } from '../../angular-material.module';

export function appInitializerFactory(translate: TranslateService, languageService: LanguageService) {
  return () => languageService.initAndWait();
}

@NgModule({ 
  imports:      [
    CommonModule,
    FormsModule,
    MatDialogModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    TranslateModule
  ],
  declarations: [
    DialogUtes,
    ClientsSocisListUTEsComponent
  ],
  exports:      [ DialogUtes, TranslateModule ],
  providers:    [ 
    {provide: MatDialogRef, useValue: {}},
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, LanguageService],
      multi: true
    }
  ]
})

export class UtesDlgModule {}
